import React from 'react';

const DIRECTION_LABELS = { support: '支持', caution: '谨慎', mixed: '分化', neutral: '中性', unknown: '缺失' };
const ACTION_LABELS = { buy: '买入', add: '加仓', hold: '持有', reduce: '减仓' };

export default function EvidenceConsistencyPanel({ analysis }) {
  if (!analysis?.items?.length) return <p className="decision-muted">暂无足够证据生成一致性分析。</p>;
  return (
    <div className="evidence-consistency-panel">
      <div className={`evidence-consistency-hero tone-${analysis.state?.tone || 'neutral'}`}>
        <div><span>一致性结论</span><strong>{analysis.state?.label}</strong><p>{analysis.summary}</p></div>
        <div className="evidence-coverage"><strong>{analysis.coverage?.pct || 0}%</strong><span>证据域覆盖</span><small>{analysis.coverage?.label}，不等于字段完整度</small></div>
      </div>

      <div className="evidence-counts">
        {Object.entries(DIRECTION_LABELS).map(([key, label]) => <div className={`direction-${key}`} key={key}><span>{label}</span><strong>{analysis.counts?.[key] || 0}</strong></div>)}
      </div>

      <div className="evidence-domain-grid">
        {analysis.items.map((item) => (
          <article className={`evidence-domain direction-${item.direction}`} key={item.key}>
            <header><span>{item.label}</span><em>{DIRECTION_LABELS[item.direction] || '未知'} · {item.strength === 'high' ? '强证据' : item.strength === 'low' ? '弱证据' : '中等证据'}</em></header>
            <p>{item.fact}</p>
            <small>来源：{item.source}</small>
            {item.note ? <small>{item.note}</small> : null}
          </article>
        ))}
      </div>

      {analysis.conflicts?.length ? (
        <div className="evidence-conflicts">
          <h4>当前主要矛盾</h4>
          {analysis.conflicts.map((item, index) => (
            <div key={`${item.positive}-${item.negative}-${index}`}>
              <span className="is-support">{item.positive}</span><p>{item.positive_fact}</p><em>VS</em><span className="is-caution">{item.negative}</span><p>{item.negative_fact}</p>
            </div>
          ))}
        </div>
      ) : null}

      {analysis.confirmations?.length ? (
        <div className="evidence-confirmations">
          {analysis.confirmations.map((item) => <div className={`direction-${item.direction}`} key={item.direction}><span>{item.direction === 'support' ? '正向确认' : '风险确认'}</span><strong>{item.labels.join(' + ')}</strong><small>{item.fact}</small></div>)}
        </div>
      ) : null}

      <div className="evidence-actions">
        {Object.entries(ACTION_LABELS).map(([key, label]) => <div key={key}><span>{label}</span><p>{analysis.actions?.[key]}</p></div>)}
      </div>
      <p className="evidence-method">{analysis.method} 本模块不进入评分。</p>
    </div>
  );
}
